import {
  LayoutDashboard, Package, Sparkles, Link2, Library, Megaphone, CalendarDays, Target, Wallet, Plug, Crown, UserRound, Store,
} from "lucide-react";

export const NAV = [
  { to: "/", label: "Painel", icon: LayoutDashboard, id: "dashboard", main: true },
  { to: "/produtos", label: "Produtos", icon: Package, id: "products", main: true },
  { to: "/gerador", label: "Gerador IA", icon: Sparkles, id: "generator", main: true },
  { to: "/links", label: "Links & QR", icon: Link2, id: "links", main: true },
  { to: "/fornecedores", label: "Fornecedores", icon: Store, id: "suppliers" },
  { to: "/biblioteca", label: "Biblioteca", icon: Library, id: "library" },
  { to: "/campanhas", label: "Campanhas", icon: Megaphone, id: "campaigns" },
  { to: "/calendario", label: "Calendário", icon: CalendarDays, id: "calendar" },
  { to: "/metas", label: "Metas", icon: Target, id: "goals" },
  { to: "/comissoes", label: "Comissões", icon: Wallet, id: "commissions" },
  { to: "/integracoes", label: "Integrações", icon: Plug, id: "integrations" },
  { to: "/planos", label: "Planos & Créditos", icon: Crown, id: "plans" },
  { to: "/perfil", label: "Perfil", icon: UserRound, id: "profile" },
];
